import { render, staticRenderFns } from "./mt4List.vue?vue&type=template&id=53413164&scoped=true"
import script from "./mt4List.vue?vue&type=script&lang=js"
export * from "./mt4List.vue?vue&type=script&lang=js"
import style0 from "./mt4List.vue?vue&type=style&index=0&id=53413164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53413164",
  null
  
)

export default component.exports